import React, { useCallback, useMemo } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const onClickHandler = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const extra = useMemo(
    () => (
      <Button type="primary" onClick={onClickHandler}>
        Back Home
      </Button>
    ),
    [onClickHandler],
  );

  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={extra}
    />
  );
};
